import { useState } from 'react';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-mail-send-line"></i>
            <span className="whitespace-nowrap">在线咨询</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
          <p className="mt-2 text-sm text-foreground-500">有任何建议或合作意向，欢迎与我们联系</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/60 text-center">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900">商务合作</h3>
              <p className="mt-1 text-xs text-foreground-500">biz@baiyunvideo.com</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/60 text-center">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className="ri-customer-service-2-line text-lg"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900">用户反馈</h3>
              <p className="mt-1 text-xs text-foreground-500">feedback@baiyunvideo.com</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/60 text-center">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                <i className="ri-chat-3-line text-lg"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900">内容投稿</h3>
              <p className="mt-1 text-xs text-foreground-500">submit@baiyunvideo.com</p>
            </div>
          </div>

          <form
            onSubmit={handleSubmit}
            data-readdy-form=""
            className="p-6 rounded-xl bg-background-50 border border-background-200/60"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  placeholder="请输入您的姓名"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  placeholder="请输入您的邮箱"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                />
              </div>
            </div>
            <div className="mb-4">
              <label htmlFor="contact-topic" className="block text-sm font-medium text-foreground-700 mb-1.5">咨询类型</label>
              <select
                id="contact-topic"
                name="topic"
                className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
              >
                <option value="">请选择咨询类型</option>
                <option value="cooperation">商务合作</option>
                <option value="feedback">用户反馈</option>
                <option value="submit">内容投稿</option>
                <option value="other">其他</option>
              </select>
            </div>
            <div className="mb-4">
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
              <textarea
                id="contact-message"
                name="message"
                rows={4}
                maxLength={500}
                placeholder="请输入您的留言内容，不超过500字"
                className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
              ></textarea>
            </div>
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="form-hp" />
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-fill mr-2"></i>发送留言
            </button>
            {submitted && (
              <p className="mt-3 text-sm text-primary-600 font-medium">感谢您的留言，我们会尽快回复！</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}